import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkMonitoring = React.lazy(async () => ({
    default: (await import('@oc/rk-monitoring/module')).ReadyKitRkMonitoring
}))

export function RkMonitoringComponent() {
    return <SuspenseWhileLoading LazyComponent={RkMonitoring} />
}

const AccountRkMonitoring = React.lazy(async () => ({
    default: (await import('@oc/rk-monitoring/module')).AccountRkMonitoring
}))

export function AccountRkMonitoringComponent() {
    return <SuspenseWhileLoading LazyComponent={AccountRkMonitoring} />
}

const GlobalRkMonitoring = React.lazy(async () => ({
    default: (await import('@oc/rk-monitoring/module')).GlobalRkMonitoringWithTheme
}))

export function GlobalRkMonitoringComponent() {
    return <SuspenseWhileLoading LazyComponent={GlobalRkMonitoring} />
}
